import { Expose, Type } from 'class-transformer';
import { addDays } from 'date-fns';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';
import { FsFormatDatePipe } from '@lib/common/pipes';

import { IChartData } from '../interfaces';

export class LprCount extends SnModel {
  @Expose()
  @Type(() => Date)
  public periodStart: Date;

  @Expose()
  @Default(0)
  public readCount: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  public chartData(mode: string): IChartData {
    if (mode === 'day') {
      const date = addDays(this.periodStart, 1);
      this.periodStart = date;
      return {
        name: new FsFormatDatePipe().transform(this.periodStart, 'mediumDate'),
        value: this.readCount,
      };
    }
    return {
      name: new FsFormatDatePipe().transform(this.periodStart, 'mediumDate'),
      value: this.readCount,
    };
  }
}
